export const climateOption = [
    { value: 'HOT', label: 'HOT' },
    { value: 'COLD', label: 'COLD' },
    { value: 'MILD', label: 'MILD' },
]
export const packingListOption = [
    { value: 'MINIMAL', label: 'MINIMAL' },
    { value: 'LITE', label: 'LITE' },
    { value: 'PREPARED', label: 'PREPARED' },
    { value: 'EXTRA_PREPARED', label: 'EXTRA_PREPARED' },
]
export const toiltryListOption = [
    { value: 'ESSENTIALS', label: 'ESSENTIALS' },
    { value: 'CARE', label: 'CARE' },
    { value: 'EXTRA_CARE', label: 'EXTRA_CARE' },
]
export const techOption = [
    { value: 'E_READER', label: 'E READER' },
    { value: 'TABLET', label: 'TABLET' },
    { value: 'LAPTOP', label: 'LAPTOP' },
    { value: 'ACTION_CAMERA', label: 'ACTION CAMERA' },
    { value: 'MIRRORLESS', label: 'MIRRORLESS' },
    { value: 'DSLR', label: 'DSLR' },
    { value: 'LENSES', label: 'LENSES' },
]
export const regionOptions = [
    { value: "Europe", label: "Europe" },
    { value: "Southern Europe", label: "Southern Europe" },
    { value: "Central Europe", label: "Central Europe" },
    { value: "Eastern Europe", label: "Eastern Europe" },
    { value: "Scandinavia", label: "Scandinavia" },
    { value: "East Asia", label: "East Asia" },
    { value: "South East Asia", label: "South East Asia" },
    { value: "North America", label: "North America" },
    { value: "South America", label: "South America" },
    { value: "Oceania", label: "Oceania" },
    { value: "Middle East", label: "Middle East" },
    { value: "Africa", label: "Africa" },
    { value: "North Africa", label: "North Africa" },
    { value: "Southern Africa", label: "Southern Africa" },
];


export const countryOptions = [
    { value: "Afghanistan", label: "Afghanistan", code: "AF" },
    { value: "Albania", label: "Albania", code: "AL" },
    { value: "Algeria", label: "Algeria", code: "DZ" },
    { value: "Andorra", label: "Andorra", code: "AD" },
    { value: "Angola", label: "Angola", code: "AO" },
    { value: "Argentina", label: "Argentina", code: "AR" },
    { value: "Armenia", label: "Armenia", code: "AM" },
    { value: "Australia", label: "Australia", code: "AU" },
    { value: "Austria", label: "Austria", code: "AT" },
    { value: "Azerbaijan", label: "Azerbaijan", code: "AZ" },
    { value: "Bahamas", label: "Bahamas", code: "BS" },
    { value: "Bahrain", label: "Bahrain", code: "BH" },
    { value: "Bangladesh", label: "Bangladesh", code: "BD" },
    { value: "Belgium", label: "Belgium", code: "BE" },
    { value: "Brazil", label: "Brazil", code: "BR" },
    { value: "Canada", label: "Canada", code: "CA" },
    { value: "China", label: "China", code: "CN" },
    { value: "Denmark", label: "Denmark", code: "DK" },
    { value: "Egypt", label: "Egypt", code: "EG" },
    { value: "Finland", label: "Finland", code: "FI" },
    { value: "France", label: "France", code: "FR" },
    { value: "Germany", label: "Germany", code: "DE" },
    { value: "Greece", label: "Greece", code: "GR" },
    { value: "India", label: "India", code: "IN" },
    { value: "Indonesia", label: "Indonesia", code: "ID" },
    { value: "Italy", label: "Italy", code: "IT" },
    { value: "Japan", label: "Japan", code: "JP" },
    { value: "Mexico", label: "Mexico", code: "MX" },
    { value: "Netherlands", label: "Netherlands", code: "NL" },
    { value: "New Zealand", label: "New Zealand", code: "NZ" },
    { value: "Norway", label: "Norway", code: "NO" },
    { value: "Pakistan", label: "Pakistan", code: "PK" },
    { value: "Philippines", label: "Philippines", code: "PH" },
    { value: "Portugal", label: "Portugal", code: "PT" },
    { value: "Russia", label: "Russia", code: "RU" },
    { value: "Saudi Arabia", label: "Saudi Arabia", code: "SA" },
    { value: "South Africa", label: "South Africa", code: "ZA" },
    { value: "South Korea", label: "South Korea", code: "KR" },
    { value: "Spain", label: "Spain", code: "ES" },
    { value: "Sweden", label: "Sweden", code: "SE" },
    { value: "Switzerland", label: "Switzerland", code: "CH" },
    { value: "Turkey", label: "Turkey", code: "TR" },
    { value: "United Arab Emirates", label: "United Arab Emirates", code: "AE" },
    { value: "United Kingdom", label: "United Kingdom", code: "GB" },
    { value: "United States", label: "United States", code: "US" }
];

export const travelPack = ["25L", "30L", "35L", "40L", "55L", "70L", "75+L"]
export const dayPack = ["15L", "20L", "25L", "28L"]
export const hipPack = ["1L", "2L", "3L", "5L", "6-8L", "10L"]


export const validate = ({ data, setError, imagePreview, creatorImagePreview, image, imageFile, creatorImageFile }) => {
    let validationErrors = {};

    if (!data?.title?.trim()) {
        validationErrors.title = 'Title is required';
        setError('title', { type: 'manual', message: 'Title is required' });
    } else if (data.title.trim().length < 3) {
        validationErrors.title = 'Title must be at least 3 characters';
        setError('title', { type: 'manual', message: 'Title must be at least 3 characters' });
    }

    if (!data?.description?.trim()) {
        validationErrors.description = 'Description is required';
        setError('description', { type: 'manual', message: 'Description is required' });
    } else if (data.description.trim().length > 185) {
        validationErrors.description = 'Description must be less than 185 characters';
        setError('description', { type: 'manual', message: 'Description must be less than 80 characters' });
    } else {
        setError('description', { type: 'manual', message: '' });
    }

    if (!data?.creator?.trim()) {
        validationErrors.creator = 'Creator is required';
        setError('creator', { type: 'manual', message: 'Creator is required' });
    } else if (data.creator.trim().length < 3) {
        validationErrors.creator = 'Creator must be at least 3 characters';
        setError('creator', { type: 'manual', message: 'Creator must be at least 3 characters' });
    }

    if (!data?.type || !['REGULAR', 'PRO'].includes(data?.type)) {
        validationErrors.type = 'Invalid type';
        setError('type', { type: 'manual', message: 'Invalid type' });
    }

    if (!data?.duration) {
        setError("duration", { type: "manual", message: "Duration is required" });
    }

    if (!data?.duration || !['3', '7', '10', '-1'].includes(data?.duration)) {
        validationErrors.duration = 'Duratuion is invalid ';
        setError('duration', { type: 'manual', message: 'Duratuion is invalid' });
    }
    if (!data?.bodyType || !['OTHER', 'MALE', 'FEMALE'].includes(data?.bodyType)) {
        validationErrors.bodyType = 'Invalid body type';
        setError('bodyType', { type: 'manual', message: 'Invalid body type' });
    }

    if (
        !data?.activityScale ||
        (!["1", "2", "3"].includes(String(data.activityScale)) && ![1, 2, 3].includes(Number(data.activityScale)))
    ) {
        validationErrors.activityScale = 'Activity Scale is invalid';
        setError('activityScale', { type: 'manual', message: 'Activity Scale is required' });
    }
    if (
        !data?.toiletry || // Checks if `toiletry` is undefined, null, or empty
        (Array.isArray(data.toiletry) && data.toiletry.length === 0) || // Checks if it's an empty array
        (!Array.isArray(data.toiletry) && !['ESSENTIALS', 'CARE', 'EXTRA_CARE'].includes(data.toiletry)) || // If not an array, validate directly
        (Array.isArray(data.toiletry) && !data.toiletry.every(item => ['ESSENTIALS', 'CARE', 'EXTRA_CARE'].includes(item))) // If it's an array, check if all elements are valid
    ) {
        validationErrors.toiletry = 'Toiletry is invalid';
        setError('toiletry', { type: 'manual', message: 'Toiletry is required' });
    }

    if (!data?.climate || !Array.isArray(data?.climate) || data?.climate.length === 0) {
        validationErrors.climate = 'Climate is required';
        setError('climate', { type: 'manual', message: 'Climate is required' });
    }
    if (!data?.packingStyle || !["MINIMAL", "LITE", "PREPARED", "EXTRA_PREPARED"].includes(data?.packingStyle)) {
        validationErrors.packingStyle = 'Invalid Packing style';
        setError('packingStyle', { type: 'manual', message: 'Packing style is required' });
    }

    // if (!data?.packingStyle || !Array.isArray(data?.packingStyle) || data?.packingStyle.length === 0) {
    //     validationErrors.packingStyle = 'Packing style is required';
    //     setError('packingStyle', { type: 'manual', message: 'Packing style is required' });
    // }

    if (!data?.tech || !Array.isArray(data?.tech) || data?.tech.length === 0) {
        validationErrors.tech = 'Tech is required';
        setError('tech', { type: 'manual', message: 'Tech is required' });
    }

    if (!data?.tags || !Array.isArray(data?.tags) || data?.tags.length === 0) {
        validationErrors.tags = 'Tags are required';
        setError('tags', { type: 'manual', message: 'Tags are required' });
    } else if (data?.tags.length > 5) {
        validationErrors.tags = 'You can only select up to 5 tags';
        setError('tags', { type: 'manual', message: 'You can only select up to 5 tags' });
    }

    // if (!data?.thumbnail && !imagePreview && !imageFile) {
    //     validationErrors.thumbnail = 'Thumbnail is required';
    //     setError('thumbnail', { type: 'manual', message: 'Thumbnail is required' });
    // }
    // if (!data?.creatorImage && !creatorImagePreview && !creatorImageFile) {
    //     validationErrors.creatorImage = 'Creator Image is required';
    //     setError('creatorImage', { type: 'manual', message: 'Creator Image is required' });
    // }
    // if (data?.type === "PRO") {
    //     if (!data?.video && !videoPreview && !videoFile) {
    //         validationErrors.video = "Video is required";
    //         setError("video", { type: "manual", message: "Video is required" });
    //     }
    // }
    // Thumbnail validation: Show error only if ALL are missing
    if (!(imagePreview || imageFile)) {
        validationErrors.thumbnail = "Thumbnail is required";
        setError("thumbnail", { type: "manual", message: "Thumbnail is required" });
    }

    // Creator Image validation: Show error only if ALL are missing
    if (!(creatorImagePreview || creatorImageFile)) {
        validationErrors.creatorImage = "Creator Image is required";
        setError("creatorImage", { type: "manual", message: "Creator Image is required" });
    }

    // Video or YouTube URL validation: Only applies if type is PRO & BOTH are missing
    if (data?.type === "PRO") {
        // const hasVideo = !!(videoPreview || videoFile);
        const hasYoutubeUrl = !!(data?.youtubeUrl && data.youtubeUrl.trim() !== "");
        if (!hasYoutubeUrl) {
            // validationErrors.video = "Upload a video or provide a YouTube URL.";
            validationErrors.youtubeUrl = "Upload a video or provide a YouTube URL.";
            // setError("video", { type: "manual", message: "Upload a video or provide a YouTube URL." });
            setError("youtubeUrl", { type: "manual", message: "Upload a video or provide a YouTube URL." });
        } else {
            // Clear errors on both fields if either is present
            // setError("video", { type: "manual", message: "" });
            setError("youtubeUrl", { type: "manual", message: "" });
            // delete validationErrors.video;
            delete validationErrors.youtubeUrl;
        }
    }

    // else {
    //     const file = data?.thumbnail; // File object

    //     // Check file type
    //     const allowedTypes = ['image/png', 'image/jpeg'];
    //     if (!allowedTypes.includes(file?.type)) {
    //         validationErrors.thumbnail = 'Invalid file type. Only PNG and JPEG are allowed.';
    //         setError('thumbnail', { type: 'manual', message: 'Invalid file type. Only PNG and JPEG are allowed.' });
    //     }

    //     // Check file size (5MB limit in this case)
    //     const maxSize = 5 * 1024 * 1024; // 5MB
    //     if (file?.size > maxSize) {
    //         validationErrors.thumbnail = 'File size exceeds the 5MB limit';
    //         setError('thumbnail', { type: 'manual', message: 'File size exceeds the 5MB limit' });
    //     }
    // }

    if (Object.keys(validationErrors).length > 0) {
        console.log("errors", validationErrors)
        return false; // There are errors, so return false
    }


    return true;
};

